module.exports = __webpack_public_path__ + "img/commabassador.e8113007.svg";